module.exports = function(app) {
    app.run(['Service','sessionData', function (Service, sessionData) {
        return new Service({

                               name: 'visionAndDental',
                               group: 'eprsvc',
                               url: '/eprsvc/x-services/secure/employer/v1/information/additional',
                               cache: false,

                               fetch: function() {
                                   if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                                       this.headers['ClientNumber']  = sessionData.clientNumber;
                                   }
                                   return this.get();
                               }
                           });
    }]);
};
